import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import useFormikSchema from '../hooks/useFormikSchema';
import TextField from '../components/TextField.jsx';
import formatError, { formatErrorWithIcon } from '../utils/formatError';

const FormikFormattedTextField = (props) => {
  const {
    disabled,
    value,
    name,
    label,
    fieldProps,
    schema,
    formatText,
    unformatText,
    ...rest
  } = props;


  const dataTestId = props['data-testid'];
  const {formattedLabel} = useFormikSchema(name, label, schema);

  return (
    <Field
      disabled={disabled}
      value={value}
      name={name}
      {...rest}>
      {
        (renderProps) => {
          const {form, meta} = renderProps;
          const {setFieldValue} = form;
          const {error} = meta;

          const finalHelperTextProps = error ? {
            ...fieldProps?.FormHelperTextProps,
            'role': 'alert',
            'aria-label': formatError( error ),
          } : fieldProps?.FormHelperTextProps;

          const handleChange = (event) => {
            const newText = event.target.value;
            setFieldValue(name, unformatText(newText));
          };

          return (
            <TextField
              fullWidth
              error={!!error}
              helperText={error ? formatErrorWithIcon( error ) : props.helperText}
              disabled={disabled}
              value={formatText(value)}
              variant={'outlined'}
              label={formattedLabel}
              data-testid={dataTestId}
              onChange={handleChange}
              {...fieldProps}
              FormHelperTextProps={finalHelperTextProps}
            />
          );
        }
      }
    </Field>
  );
};

FormikFormattedTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  formatText: PropTypes.func.isRequired,
  unformatText: PropTypes.func.isRequired,
};

FormikFormattedTextField.defaultProps = {
  fieldProps: {},
};

export default FormikFormattedTextField;
